import { render, staticRenderFns } from "./application.vue?vue&type=template&id=0c85af4d&scoped=true&"
import script from "./application.vue?vue&type=script&lang=js&"
export * from "./application.vue?vue&type=script&lang=js&"
import style0 from "./application.vue?vue&type=style&index=0&id=0c85af4d&prod&lang=sass&scoped=true&"
import style1 from "./application.vue?vue&type=style&index=1&id=0c85af4d&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85af4d",
  null
  
)

export default component.exports